<!-- 订阅中心 -->
<template>
    <div>
      <div id="taskDialog">
        <el-dialog title="订阅中心" :visible.sync="dialogVisible" width="800px" :before-close="subscriptionClose">
          <el-form :inline="true" size="mini" style="margin-top:10px;" @submit.native.prevent>
            <el-form-item>
              <el-input size="mini" v-model.trim="getRequestData" clearable @keyup.native.enter="searchData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="searchData">查询</el-button>
            </el-form-item>
          </el-form>
          <el-tabs type="border-card" v-if="filterData" id="dyCenter" v-model="tabsActive">
            
            <el-tab-pane v-if="filterData.taskModuleVo">
              <span slot="label"><i :class="filterData.taskModuleVo['pattern']"></i> {{filterData.taskModuleVo['menuName']}}</span>
              <div v-if="selectData0.length > 0">
                <div v-for="val in selectData0" :key="val.configId" class="subSC_iBody_item">
                  <div><i></i>{{val.configName}}</div>
                  <div>
                    <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,0)"><i
                        :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                  </div>
                </div>
              </div>
              <div v-if="selectData0.length == 0">
                <el-collapse v-model="activeNames" v-if="filterData.taskModuleVo.groupVoList.length && filterData.taskModuleVo.groupVoList.length>0" accordion>
                  <el-collapse-item v-for="(item,i) in filterData.taskModuleVo.groupVoList" :key="i" :title="item.groupName" :name="i">
                    <div>
                      <div v-for="val in item.desysModuleVoList" :key="val.configId" class="subSC_iBody_item">
                        <div><i></i>{{val.configName}}</div>
                        <div>
                          <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,0)"><i
                              :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              
              <div v-if="filterData.taskModuleVo.groupVoList.length == 0" style="text-align:center;">暂无内容</div>
            </el-tab-pane>
            <el-tab-pane v-if="filterData.plateModuleVo">
              <span slot="label"><i :class="filterData.plateModuleVo['pattern']"></i> {{filterData.plateModuleVo['menuName']}}</span>
              <div v-if="selectData1.length > 0">
                <div v-for="val in selectData1" :key="val.configId" class="subSC_iBody_item">
                  <div><i></i>{{val.configName}}</div>
                  <div>
                    <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,1)"><i
                        :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                  </div>
                </div>
              </div>
              <div v-if="selectData1.length == 0">
                <el-collapse v-model="activeNames" v-if="filterData.plateModuleVo.groupVoList.length && filterData.plateModuleVo.groupVoList.length>0" accordion>
                  <el-collapse-item v-for="(item,i) in filterData.plateModuleVo.groupVoList" :key="i" :title="item.groupName" :name="i">
                    <div>
                      <div v-for="val in item.desysModuleVoList" :key="val.configId" class="subSC_iBody_item">
                        <div><i></i>{{val.configName}}</div>
                        <div>
                          <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,1)"><i
                              :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                        </div>
                      </div>
                    </div>
    
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div v-if="filterData.plateModuleVo.groupVoList.length == 0" style="text-align:center;">暂无内容</div>
            </el-tab-pane>
            <el-tab-pane v-if="filterData.warnModuleVo">
              <span slot="label"><i :class="filterData.warnModuleVo['pattern']"></i> {{filterData.warnModuleVo['menuName']}}</span>
              <div v-if="selectData2.length > 0">
                <div v-for="val in selectData2" :key="val.configId" class="subSC_iBody_item">
                  <div><i></i>{{val.configName}}</div>
                  <div>
                    <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,2)"><i
                        :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                  </div>
                </div>
              </div>
              <div v-if="selectData2.length == 0">
                <el-collapse v-model="activeNames" v-if="filterData.warnModuleVo.groupVoList.length && filterData.warnModuleVo.groupVoList.length>0" accordion>
                  <el-collapse-item v-for="(item,i) in filterData.warnModuleVo.groupVoList" :key="i" :title="item.groupName" :name="i">
                    <div>
                      <div v-for="val in item.desysModuleVoList" :key="val.configId" class="subSC_iBody_item">
                        <div><i></i>{{val.configName}}</div>
                        <div>
                          <span :class="val.isSubscribe == '0'?'subSC_sub':''" @click="setSubscribeStatus(val.isSubscribe,val.isSubscribe == '0'?val.configId:val.subId,2)"><i
                              :class="val.isSubscribe == '0'?'subSC_sub':'el-icon-star-off'"></i>{{val.isSubscribe == '0'?'订阅':'取消订阅'}}</span>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div v-if="filterData.warnModuleVo.groupVoList.length == 0" style="text-align:center;">暂无内容</div>
            </el-tab-pane>
          </el-tabs>
          <span slot="footer" class="dialog-footer">
            <el-button @click="subscriptionClose">关 闭</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SubscriptionCenter",
    data() {
      return {
        activeNames: ["1", "2", "3"],
        colorList: ["#00BFDD", "#7874CE", "#FFAB00", "#E64C66"], //一级，二级，三级，四级
        dialogVisible: false,
        createDialogVisible: false,
        options: [
          {
            value: "1",
            label: "1级",
          },
          {
            value: "2",
            label: "2级",
          },
          {
            value: "3",
            label: "3级",
          },
          {
            value: "4",
            label: "4级",
          },
        ],
        createTaskData: {
          reminderType: 0,
          taskContent: "",
          taskLevel: "1",
          taskName: "",
          taskReceiver: "",
          taskReceiverName: "",
          taskRemark: "",
        },
  
        filterData: {}, //获取数据
        filterData: {}, //查询数据
        changeFlag: false, //是否改变
        changeType: [], //订阅修改类型
        getRequestData: "", //搜索条件
        tabsActive: 0, //tabs活动选项
        selectData0: [],
        selectData1: [],
        selectData2: [],
      };
    },
    methods: {
      //搜索查询
      searchData() {
        var reg = new RegExp(this.getRequestData, "g");
        // console.log(reg.test(v.configName))
        switch (parseFloat(this.tabsActive)) {
          case 0:
            if (this.getRequestData == '') {
              this.selectData0 = []
              return
            }
            if ( !this.filterData.taskModuleVo.groupVoList.length || this.filterData.taskModuleVo.groupVoList.length < 1 ) { break; }
            this.filterData.taskModuleVo.groupVoList.forEach((item)=>{
                for (let index = 0; index < item.desysModuleVoList.length; index++) {
                    if (item.desysModuleVoList[index].configName.indexOf(this.getRequestData) != -1) {
                        this.selectData0.push(item.desysModuleVoList[index])
                    }
                    
                }
            })
            break;
          case 1:
            if (this.getRequestData == '') {
              this.selectData1 = []
              return
            }
            if ( !this.filterData.plateModuleVo.groupVoList.length || this.filterData.plateModuleVo.groupVoList.length < 1 ) {break;}
            this.filterData.plateModuleVo.groupVoList.forEach((item)=>{
                for (let index = 0; index < item.desysModuleVoList.length; index++) {
                    if (item.desysModuleVoList[index].configName.indexOf(this.getRequestData) != -1) {
                        this.selectData1.push(item.desysModuleVoList[index])
                    }
                  
                }
            })
            break;
          case 2:
            if (this.getRequestData == '') {
              this.selectData2 = []
              return
            }
            if ( !this.filterData.warnModuleVo.groupVoList.length || this.filterData.warnModuleVo.groupVoList.length < 1 ) {break;}
            this.filterData.warnModuleVo.groupVoList.forEach((item)=>{
                for (let index = 0; index < item.desysModuleVoList.length; index++) {
                    if (item.desysModuleVoList[index].configName.indexOf(this.getRequestData) != -1) {
                        this.selectData2.push(item.desysModuleVoList[index])
                    }
                }
            })
            break;
        }
      },
  
      //设置当前用户的订阅信息
      setSubscribeStatus(status, id, typ) {
        this.$http
          .setSubscribeStatus({
            ids: [id], //	配置ID
            status: status, //	状态0.新增1.取消
            subType: typ, //	订阅类型0.任务1.板块2.预警
          })
          .then((res) => {
            if (res && res.status == 200) {
              this.changeType.push(typ);
              this.changeFlag = true;
              this.getUserSubscribeData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((rej) => {
            this.$message({
              message: rej.message,
              type: "error",
            });
          });
      },
  
      //向父级推送
      subscriptionClose() {
        this.dialogVisible = false;
        let obj = {
          status: this.dialogVisible,
          flag: this.changeFlag,
          type: this.changeType,
        };
        this.$emit("subscriptionClose", obj);
  
        this.changeFlag = false;
        this.changeType = [];
      },
  
      //查询当前用户的订阅信息
      getUserSubscribeData() {
        this.$http
          .queryUserSubscribeData()
          .then((res) => {
            //   console.log("queryUserSubscribeData", res);
            if (res && res.status == 200) {
              // this.filterData = JSON.parse(JSON.stringify(res.result));
              this.filterData = JSON.parse(JSON.stringify(res.result));
              //console.log(this.filterData);
              this.dialogVisible = true;
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((rej) => {
            this.$message({
              message: rej.message,
              type: "error",
            });
          });
      },
  
      //获取颜色
      getColor(str) {
        str = str.toString();
        if (
          str == 1 ||
          str == "一" ||
          str.indexOf("1") > 0 ||
          str.indexOf("一") > 0
        ) {
          return this.colorList[0];
        } else if (
          str == 2 ||
          str == "二" ||
          str.indexOf("2") > 0 ||
          str.indexOf("二") > 0
        ) {
          return this.colorList[1];
        } else if (
          str == 3 ||
          str == "三" ||
          str.indexOf("3") > 0 ||
          str.indexOf("三") > 0
        ) {
          return this.colorList[2];
        } else {
          return this.colorList[3];
        }
      },
      //获取状态0.初始1.关闭（发起人）2.完成3.拒绝（接收人）
      getTaskStatus(num) {
        if (num == 0) {
          return "初始";
        } else if (num == 1) {
          return "关闭";
        } else if (num == 2) {
          return "完成";
        } else {
          return "拒绝";
        }
      },
      //初始化
      init() {
        for (const key in this.createTaskData) {
          this.createTaskData[key] = "";
        }
        this.createTaskData.reminderType = 0;
        this.createTaskData.taskLevel = "1";
        this.$refs["createTaskData"].resetFields();
      },
    },
    created() {
      this.getUserSubscribeData();
    },
  };
  </script>
  
  <style scoped>
  ::v-deep #taskDialog .el-dialog {
    /* height: 96%; */
    /* overflow: auto; */
    margin-bottom: 0;
  }
  
  /* ::v-deep #taskDialog .el-dialog__body {
      height: 83%;
      box-sizing: border-box;
      padding: 0 1rem !important;
  } */
  
  .el-dialog__footer {
    padding: 20px 0 0 0;
  }
  
  .el-tabs {
    margin: 0;
    /* overflow: auto; */
  }
  
  ::v-deep .el-tabs__body {
    height: 100%;
  }
  
  .el-collapse {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .el-collapse-item {
    scrollbar-width: none;
    flex: 1;
    /* overflow-y: scroll; */
  }
  
  .el-collapse-item__header {
    background-color: rgb(192, 85, 85);
  }
  
  .subSC_iBody::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .subSC_iBody::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #c1c1c1;
  }
  .subSC_iBody::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(255, 255, 255, 1);
    border-radius: 10px;
    background: #f1f1f1;
  }
  
  /* .subSC_iBody::-webkit-scrollbar {display:none} */ /*隐藏滚动条*/
  /* .subSC_itemBox::-webkit-scrollbar {display:none} */
  
  .subSC_iBody {
    padding: 10px 0;
    overflow-y: auto;
    height: 490px;
  }
  
  .subSC_iBody_item {
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .subSC_iBody_item:nth-child(even) {
    background-color: #f5f7fa;
  }
  
  .subSC_sub {
    margin-right: 20px;
    color: #409eff;
  }
  
  .footer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep #dyCenter .el-tabs__content {
    height: 440px;
    overflow: auto;
  }
  </style>